import errorMessage from '../../constants/messages';

export default resp => {
  if (!resp.ok) {
    if (resp.status >= 400 && resp.status < 500) {
      return resp.json().then(data => {
        const err = { errorMessage: data.error || errorMessage.errorFrom400to500 };
        throw err;
      });
    }
    const err = { errorMessage: `Ошибка ${resp.status} - ${errorMessage.errorReqRes}` };
    throw err;
  }
  return resp.json();
};
